import { render, staticRenderFns } from "./BornInCanada.vue?vue&type=template&id=7717bb48&scoped=true&"
import script from "./BornInCanada.vue?vue&type=script&lang=js&"
export * from "./BornInCanada.vue?vue&type=script&lang=js&"
import style0 from "./BornInCanada.vue?vue&type=style&index=0&id=7717bb48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7717bb48",
  null
  
)

export default component.exports